import React, { useEffect, useState } from 'react'
import { adminLogout, checkAuth } from '../backend'
import LoginForm from './LoginForm'
import AdminSeatManagement from './AdminSeatManagement'
import PriceSelection from './PriceSelection'
import AdminImageManagement from './AdminImageManagement'
import AdminScheduleManagement from './AdminScheduleManagement'
import { Box, Button, Tab, Tabs, Typography } from '@mui/material'

export default function Admin() {
  const [authenticated, setAuthenticated] = useState(false)
  const [tab, setTab] = useState(0)

  useEffect(() => {
    let cancelled = false
    checkAuth()
      .then((res) => {
        if (!cancelled && res.authenticated) {
          setAuthenticated(true)
        }
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [])

  const handleLogout = async () => {
    await adminLogout({})
    setAuthenticated(false)
    window.location.href = '/'
  }

  const handleChange = (_, value) => setTab(value)

  const renderContent = () => {
    switch (tab) {
      case 0:
        return <AdminSeatManagement />
      case 1:
        return <PriceSelection />
      case 2:
        return <AdminScheduleManagement />
      case 3:
        return <AdminImageManagement />
      default:
        return null
    }
  }

  return authenticated ? (
    <Box sx={{ zIndex: 1 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant='h5' component='h5'>
          Section admin
        </Typography>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tab} onChange={handleChange} centered>
            <Tab label='Sièges' />
            <Tab label='Prix' />
            <Tab label='Séances' />
            <Tab label='Images' />
          </Tabs>
        </Box>
        <Button variant='contained' color='error' onClick={handleLogout}>
          Déconnection
        </Button>
      </Box>

      {renderContent()}
    </Box>
  ) : (
    <LoginForm setAuthenticated={setAuthenticated} />
  )
}

Admin.propTypes = {}
